import { useSelector } from "react-redux";
import { modulesNameSynonymMapper } from "@Services/constants";
import { Breadcrumbs, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import IconComponent from "@CubeComponents/icons";
import Text from "@CubeComponents/html/Text/Text";
import React from "react";

function BreadCrumbNav() {
  const breadCrumbData = useSelector((state) => state.breadCrumbData);
  const navigate = useNavigate();

  const linkStyle = {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    color: "#192048",
  };

  const handleTextModification = (text) => {
    if (text == "Spaces") {
      return window.location.host.includes("dpmsportal") ? `${modulesNameSynonymMapper.spaces}` : "Spaces";
    } else if (text == "Projects") {
      return window.location.host.includes("dpmsportal") ? `${modulesNameSynonymMapper.projects}` : "Projects";
    }
    return text;
  };

  const handleLinkClick = (link) => {
    navigate(link);
  };

  const createLink = ({ text, link }, index) => {
    const displayText = handleTextModification(text);
    const isLastItem = index === breadCrumbData.length - 1;

    let content;
    if (link && !isLastItem) {
      content = (
        <Link underline="hover" onClick={() => handleLinkClick(link)} sx={linkStyle}>
          {displayText}
        </Link>
      );
    } else {
      content = displayText;
    }
    return content;
  };

  return (
    <Breadcrumbs separator={<IconComponent name="arrowRight" className="h-3.5 curso" />}>
      {breadCrumbData.map((data, index) => {
        return (
          <React.Fragment key={`breadCrumb-${index}`}>
            {data.template ? (
              data.template()
            ) : (
              <div className="max-w-[150px] block text-sm text-[#192048]">
                <Text
                  placement="bottom"
                  tooltipContent={data.showTooltip ? data.tooltipData : null}
                  key={`$breadCrumb-withTooltip-${index}`}
                >
                  {createLink(data, index)}
                </Text>
              </div>
            )}
          </React.Fragment>
        );
      })}
    </Breadcrumbs>
  );
}

export default BreadCrumbNav;
